import { render, staticRenderFns } from "./student-case.vue?vue&type=template&id=1a9843c4"
import script from "./student-case.vue?vue&type=script&lang=js"
export * from "./student-case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports